"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Veeam = function Veeam(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.63 9.842c-1.104 0-2.001.945-2.001 2.101v.108c0 1.322.847 2.038 1.975 2.101.051.006.108.006.16.006.435 0 .794-.115 1.195-.361.04-.023.201-.132.361-.338.132-.166.138-.411 0-.543-.2-.189-.412-.086-.595.074-.292.246-.516.442-1.1.442-.55 0-1.064-.316-1.19-.94 0-.023.01-.045.034-.045H8.16a.473.473 0 00.469-.504c0-1.156-.893-2.101-1.998-2.101zm4.466 0c-1.1 0-1.996.945-1.996 2.101v.108c0 1.322.846 2.038 1.974 2.101.052.006.109.006.16.006.435 0 .795-.115 1.196-.361.04-.023.2-.132.361-.338.132-.166.137-.411 0-.543-.2-.189-.413-.086-.596.074-.292.246-.515.442-1.1.442-.549 0-1.063-.316-1.189-.94-.006-.023.01-.045.028-.045h2.691a.473.473 0 00.469-.504c-.006-1.156-.9-2.101-1.998-2.101zm-6.89.04a.4.4 0 00-.345.223l-1.42 3.063c-.034.063-.062.11-.136.11-.075 0-.105-.047-.139-.11l-1.42-3.057a.38.38 0 00-.531-.177.428.428 0 00-.172.56l1.39 2.828.16.32a.8.8 0 00.712.46.791.791 0 00.709-.46l.16-.32 1.385-2.834a.423.423 0 00-.166-.56.376.376 0 00-.188-.045zm11.362 0a.762.762 0 00-.504.188.808.808 0 00-.207.27l-1.591 3.137c0 .005-.006.006-.006.011v.006a.434.434 0 00.029.442c0 .005.006.006.006.011 0 .006.006.004.006.01a.372.372 0 00.516.076s.005 0 .005-.006a.083.083 0 00.024-.017l.015-.018.006-.006a.485.485 0 00.076-.103l.057-.125.332-.7c.006-.017.028-.027.045-.027h1.484c.195 0 .354-.167.354-.379 0-.206-.159-.377-.354-.377h-1.099c-.023 0-.041-.024-.03-.046l.08-.172.602-1.207v-.006s0-.006.006-.006c.011-.023.04-.108.098-.125.034-.012.063-.012.086 0 .063.017.084.091.113.148l1.455 3.022a.393.393 0 00.48.195s.006 0 .006-.006l.035-.017c.006 0 .007-.006.012-.006 0 0 .006 0 .006-.006.006 0 .006-.006.012-.006s.01-.004.01-.01c.006 0 .006-.006.011-.006.006-.006.012-.012.018-.012l.017-.017.006-.006a.408.408 0 00.092-.498l-1.598-3.154a.79.79 0 00-.709-.451zm3.508 0c-.39 0-.709.332-.709.778v3.018c0 .183.104.354.264.406.263.086.486-.143.486-.412l-.058-2.938a.03.03 0 01.052-.017l1.442 2.931c.137.28.367.448.625.448.257 0 .491-.167.623-.448l1.449-2.935c.011-.029.05-.019.05.016l-.056 2.955c0 .234.177.423.389.412.206-.006.367-.207.367-.43V10.66c.011-.452-.31-.771-.7-.777a.684.684 0 00-.61.394c-.361.739-1.426 2.93-1.426 2.936-.006.011-.029.064-.075.064-.04 0-.068-.047-.074-.064-.349-.727-1.047-2.164-1.408-2.908-.143-.287-.379-.422-.63-.422zm-12.451.647c.698 0 1.14.527 1.209 1.145 0 .023-.012.045-.035.045h-2.33c-.023-.006-.033-.022-.033-.045.074-.607.49-1.145 1.189-1.145zm4.47 0h.003c.697.001 1.138.527 1.207 1.145 0 .023-.013.045-.035.045H9.94c-.023-.006-.04-.022-.034-.045.075-.606.493-1.144 1.19-1.145z"
  }));
};

Veeam.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Veeam.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Veeam;
exports.default = _default;